/**
 * useDfe Hook
 *
 * React Query hook for fetching a job's DFE submissions.
 */

import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { getDfe } from '../api/dfeApi';

export function useDfe(jobId: number) {
  const query = useQuery({
    queryKey: queryKeys.jobs.dfe(String(jobId)),
    queryFn: () => getDfe(jobId),
    enabled: jobId > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
